import { Bugfender } from '@bugfender/sdk';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';

import { App } from './App';
import {
  BASE_URL,
  VITE_BUGFENDER_APP_KEY,
  VITE_BUILD_ID,
  VITE_ENVIRONMENT,
  VITE_PROD,
  VITE_VERSION,
} from './constants/configs';

const basename = BASE_URL || '/';

if (VITE_BUGFENDER_APP_KEY) {
  Bugfender.init({
    appKey: VITE_BUGFENDER_APP_KEY,
    logUIEvents: false,
    build: VITE_BUILD_ID,
    version: VITE_VERSION,
  });
  Bugfender.setDeviceKey('environment', VITE_ENVIRONMENT);
}

const root = createRoot(document.getElementById('root')!);

if (VITE_PROD) {
  root.render(
    <StrictMode>
      <BrowserRouter basename={basename}>
        <App />
      </BrowserRouter>
    </StrictMode>,
  );
} else {
  root.render(
    <BrowserRouter basename={basename}>
      <App />
    </BrowserRouter>,
  );
}
